class AltPointsBadge extends HTMLElement {
  constructor() {
    super()
    this.points = 0
    this['points-classification'] = 'pts'
    this.multiplier = 1
    this['multiplier-classification'] = ''
  }
  connectedCallback() {
    const shadow = this.attachShadow({ mode: 'open' })
    const template = document.getElementById('alt-points-badge').content.cloneNode(true)
    template.querySelector('.point-value').textContent = this.points
    template.querySelector('.point-classification').textContent = this['points-classification']
    if (parseInt(this.multiplier, 10) > 1) {
      template.querySelector('.multiplier-value').textContent = `X${this.multiplier}`
    }
    
    if (parseInt(this.multiplier, 10) <= 1 || this.multiplier === 'undefined') {
      template.querySelector('.multiplier-container').style.visibility = 'hidden'
    } else {
      template.querySelector('.multiplier-container').style.visibility = 'unset'
    }

    if (this["multiplier-classification"]) {
      const multiplierClassification = template.querySelector('.multiplier-classification')
      multiplierClassification.textContent = this['multiplier-classification']
      multiplierClassification.style.display = 'block'
    }

    if (this.points === 0 || this.points === '0') {
      this.points = 0
      template.querySelector('.alt-points-badge').style.visibility = 'hidden'
    }

    shadow.appendChild(template)
  }

  attributeChangedCallback(property, oldValue, newValue) {
    if (oldValue === newValue) {
      return
    }

    this[property] = newValue
  }

  static get observedAttributes() {
    return ['points', 'points-classification', 'multiplier', 'multiplier-classification']
  }
}

customElements.define('alt-points-badge', AltPointsBadge)